export default __webpack_public_path__ + "static/Corprate_Careers_03-a3238cd97db81101a9991632e8397e9f.jpg";